import { Avatar } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

const ProvidersList = ({ rows, columnsExtra }) => {
  const initialStateDataGrid = {
    pagination: {
      paginationModel: {
        pageSize: 15
      }
    }
  };

  const pageSizes = [1, 5, 10, 15, 25, 50];

  const columns = [
    {
      field: 'icon',
      headerName: '',
      flex: 1,
      renderCell: (params) => <Avatar alt={params.row.iconSrc} src={params.row.icon} />
    },
    { field: 'partner', headerName: 'Partner', flex: 1, minWidth: 100 },
    {
      field: 'fullName',
      headerName: 'Nombre',
      flex: 1.2,
      renderCell: (params) => `${params.row.name} ${params.row.lastName}`,
      minWidth: 120
    },
    { field: 'email', headerName: 'Email', flex: 2, minWidth: 200 },
    { field: 'phone', headerName: 'Telefono', flex: 1.5, minWidth: 150 },
    // { field: 'website', headerName: 'Website', flex: 2.2, minWidth: 200 },
    // { field: 'tag', headerName: 'Tag', flex: 2.2, minWidth: 200 },
    ...columnsExtra
  ];

  return (
    <DataGrid initialState={initialStateDataGrid} pageSizeOptions={pageSizes} rows={rows} columns={columns} disableRowSelectionOnClick />
  );
};

export default ProvidersList;
